import { Component, inject } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { ArtistModalComponent } from '../../pages/artist/artist-modal/artist-modal.component';
import { ModalType } from '@utils/enums';
import { ArtworkDetailModalComponent } from '../../pages/inventory/artwork-detail-modal/artwork-detail-modal.component';

@Component({
  selector: 'art-modal-switch-box',
  templateUrl: './modal-switch-box.component.html',
  styleUrl: './modal-switch-box.component.scss',
  imports: [ArtistModalComponent, ArtworkDetailModalComponent],
})
export class ModalSwitchBoxComponent {
  modalService = inject(ModalService);
  protected readonly ModalType = ModalType;
}
